import { NUMBER_REGEX, SPECIAL_CHARACTERS_REGEX } from '../../../data/constants';
import messages from '../../messages';

export const INVALID_NAME_REGEX = /[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)?/gi; // eslint-disable-line no-useless-escape
export const urlRegex = new RegExp(INVALID_NAME_REGEX);

const validateFullName = (value = '', formatMessage) => {
  const full_name = value.trim();

  if (!full_name) {
    return formatMessage(messages['empty.full_name.field.error']);
  }

  if (SPECIAL_CHARACTERS_REGEX.test(full_name)) {
    return formatMessage(messages['full_name.validation.special.characters.message']);
  }

  if (NUMBER_REGEX.test(full_name)) {
    return formatMessage(messages['full_name.validation.numbers.message']);
  }

  if (full_name.split(/\s+/).length < 2) { 
    return formatMessage(messages['full_name.validation.message']);
  }

  return '';
};

export default validateFullName;
